import React from 'react';
import { useSelector } from 'react-redux';
import { Card, CardBody } from "reactstrap";
import { createSelector } from 'reselect';
import checkPermission from '../../../../Components/Hooks/PermissionHook';

function AddOperationCard({ avatar = "bx bx-user-circle", color = "primary", header = "Header", text = "lorem ipsum", textColor = 'primary', onClick }) {
  const selectBrandPath = createSelector(state => state.MenuData, state => state.brandPath);
  const brandPath = useSelector(selectBrandPath);

  return (
    <Card className='w-100 h-100'>
      <CardBody className='d-flex flex-column align-items-center'>
        <div className='avatar-sm flex-shrink-0 mb-3'>
          <span className={`avatar-title rounded fs-3 bg-${color}-subtle`}>
            <i className={`${avatar} text-${textColor}`}></i>
          </span>
        </div>
        <h6 className='fs-15 mb-3 text-center'>{header}</h6>
        <p className='mb-1 text-muted text-center'>{text}</p>
        {checkPermission("brands", brandPath, "feedEdit") ?
          <button className={`w-100 btn btn-${color} mt-auto mb-0`} type='button' onClick={onClick}>Add New</button>
          : null}
      </CardBody>
    </Card>
  )
}

export default AddOperationCard;